import React from "react";
import { useTranslation } from "react-i18next";
import BannerSectionStyle5 from "../Section/BannerSection/BannerSectionStyle5";
import ContactForm from "../ContactForm";
import Section from "../Section";
import ContactInfoSection from "../Section/ContactInfoSection";
import { pageTitle } from "../../helpers/PageTitle";
import SEO from '../SEO';

export default function Contact() {
  const { t } = useTranslation();
  pageTitle(t("contact.pageTitle"));

  return (
    <>
      <SEO title="Kontakt" description="Na kontaktoni për çdo pyetje rreth produkteve dhe shërbimeve tona farmaceutike." url="/contact" />
      <BannerSectionStyle5
        bgUrl="/images/contact/banner_bg.svg"
        imgUrl="/images/banner/banner_6.jpg"
        title={t("contact.bannerTitle")}
        subTitle={t("contact.bannerSubtitle")}
      />
      <div className="container cs_mt_minus_110">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <ContactForm />
          </div>
        </div>
      </div>
      <Section
        topMd={200}
        topLg={150}
        topXl={100}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <ContactInfoSection sectionTitle={t("contact.findUsTitle")} />
      </Section>
    </>
  );
}
